import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) onClick();
    if (href) window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-accent hover:bg-accent-hover text-white font-oswald text-xl md:text-2xl uppercase py-4 px-8 tracking-wider transition-colors duration-200 shadow-[0_0_20px_rgba(249,115,22,0.3)] hover:shadow-[0_0_30px_rgba(249,115,22,0.5)] ${className}`} data-id="element-14">
      {children}
    </motion.button>;
}